import { getAuthHeaders, handleAPIResponse } from '@/utils/apiUtils';
import { Employee, EmployeeRole } from '@/types/employee';

const API_BASE_URL = `${process.env.NEXT_PUBLIC_API_URL}`;

/** PUT /employees/:id — profile (name/phone/countryCode) or org admin (name/email/role); server branches by body keys */
export type PutEmployeeBody = {
  name?: string;
  phone?: string;
  countryCode?: string;
  email?: string;
  role?: EmployeeRole;
  departments?: string[];
  jobAccessIds?: string[];
};

export const employeeApi = {
  getEmployee: async () => {
    const response = await fetch(`${API_BASE_URL}/employees/self`, {
      headers: getAuthHeaders(),
    });
    return handleAPIResponse<{ employee: Employee }>(response);
  },

  updateEmployee: async ({ id, data }: { id: string; data: PutEmployeeBody }) => {
    const response = await fetch(`${API_BASE_URL}/employees/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleAPIResponse<{ employee: Employee }>(response);
  },

  getAuthURL: async () => {
    const response = await fetch(`${API_BASE_URL}/employees/sync-calendar/auth-url`, {
      headers: getAuthHeaders(),
    });
    return handleAPIResponse<{ url: string }>(response);
  },

  setAuthToken: async (code: string) => {
    const response = await fetch(`${API_BASE_URL}/employees/sync-calendar/auth-token`, {
      headers: getAuthHeaders(),
      method: 'POST',
      body: JSON.stringify({ code }),
    });
    return handleAPIResponse<{ tokens: string }>(response);
  },
};
